import { render, staticRenderFns } from "./messageDialog.vue?vue&type=template&id=1d20a29d&scoped=true"
import script from "./messageDialog.vue?vue&type=script&lang=js"
export * from "./messageDialog.vue?vue&type=script&lang=js"
import style0 from "./messageDialog.vue?vue&type=style&index=0&id=1d20a29d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20a29d",
  null
  
)

export default component.exports